import clsx from 'clsx'
import React, { forwardRef, FunctionComponent, ReactNode, Ref } from 'react'

import { KINDS, TIMELINE_DISPLAY_NAME } from './constants'
import styles from './style.module.scss'
import { TimelineContext } from './TimelineContext'
import { ItemAlign } from './TimelineItem'

type KindsType = typeof KINDS
type KindsKeys = keyof KindsType
export type TimelineKinds = KindsType[KindsKeys]

export interface TimelineProps {
  children: ReactNode
  align?: ItemAlign
  title?: string
  kind?: TimelineKinds
  hideLine?: boolean
  testNameSpace?: string
}

export type TimelineComponent = FunctionComponent<TimelineProps>

const TimelineBase = forwardRef<HTMLDivElement, TimelineProps>(
  ({ kind, children, testNameSpace = 'timeline-block' }: TimelineProps, ref: Ref<HTMLDivElement>) => {
    const cls = clsx(styles.timelineContainer, kind === 'Vertical' && styles.timelineContainerV)
    return (
      <TimelineContext.Provider value={{ kind }}>
        <ul className={cls} data-testid={testNameSpace}>
          {children}
        </ul>
      </TimelineContext.Provider>
    )
  }
)

export const BaseTimeline = TimelineBase

BaseTimeline.displayName = TIMELINE_DISPLAY_NAME
TimelineBase.displayName = TIMELINE_DISPLAY_NAME
